import {makeGetSidebar} from 'main/factories/usecases';

export const getSidebar = async () => makeGetSidebar().get();
